import { QueryStatus, QueryStatusType } from 'src/types'
import { useEffect, useState } from 'react'
import { HttpWRC, OperacionWRC } from '../api'

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

// type UseOperacionResult<TOperacion> =
//     | {
//           status: QueryStatus.Success
//           isSuccess: true
//           operacion: TOperacion
//       }
//     | {
//           status: QueryStatus.Error | QueryStatus.Loading | QueryStatus.Idle
//           isSuccess: false
//           operacion: never
//       }

// type OperacionResultIdle = {
//     status: QueryStatus.Idle
//     operacion: never
// }
// type OperacionResultLoading = {
//     status: QueryStatus.Loading
//     operacion: never
// }
// type OperacionResultError = {
//     status: QueryStatus.Error
//     operacion: never
// }
// type OperacionResultSuccess<TOperacion> = {
//     status: QueryStatus.Success
//     operacion: TOperacion
// }

export const useOperacionWRC: (idOperacion: number) => UseOperacionResult<OperacionWRC> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionWRC>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpWRC.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
